import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7de2674e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7de2674e')) {
      api.createRecord('7de2674e', component.options)
    } else {
      api.reload('7de2674e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7de2674e&", function () {
      api.rerender('7de2674e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/Knowledge/index.vue"
export default component.exports